import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-countact-us",
  templateUrl: "./countact-us.component.html",
  styleUrls: ["./countact-us.component.scss"],
})
export class CountactUsComponent implements OnInit {
  constructor(private generalService: GeneralService) {}
  genericDetails: any = [];

  ngOnInit(): void {
    this.generalService.getGenericDetailsData().subscribe((data) => {
      this.genericDetails = data;
    });
  }
}
